/*
import React, {Component} from 'react';
import {
  TouchableOpacity,
  View,
  Text
} from 'react-native';
*/

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import i10v1a from './i10v1a'; // 設備情報
import i11v1a from './i11v1a'; // 時間帯情報
//import c10v1b from './c10v1b'; // 団体情報
import i1zv1b from './i1zv1b'; // 予約・エントリー情報
import c20v1a from './c20v1a'; // 設定

import cView from './cView';

export default class i1yv extends cView { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  s_i1yrs11i: 0,
  s_i1yrs12i: 0,
  s_i1yri11dStt: null,
  s_i1yri11dEnd: null,
};

$clp_bfrLoadLists = () => [
  new Promise( _o_end1 => {
    let _stt = (global.t?.state.s_i1yri11dStt == null) ? ff.myDT_getDate('today') : global.t?.state.s_i1yri11dStt;
    let _end = (global.t?.state.s_i1yri11dEnd == null) ? null : global.t?.state.s_i1yri11dEnd;
    cf.myRN_setStt({
      s_i1yri11dStt: _stt,
      s_i1yri11dEnd: _end,
    })
    .then(_o_end1);
  })
];

static op_loadList = pd => 
  (pd.elm == 'i1yr') ?
    super.op_loadList({
      ...pd,
      o_cnd: 
      ( global.t?.class == 'i1yv1a') ?
        _dd_datss => {
          let _cnd = cf.c('i1yr', 'i1yri11i > 0', false, false); // i1yr は歴管理対象外
          if (ff.f(global.t?.state.s_i1yri11dStt)) _cnd += ` AND i1yri11d >= "${global.t?.state.s_i1yri11dStt}"`; // 利用日
          if (ff.f(global.t?.state.s_i1yri11dEnd)) _cnd += ` AND "${global.t?.state.s_i1yri11dEnd}" >= i1yri11d`; // 利用日
          if (global.t?.state.s_i1yrs11i >= 0) _cnd += ` AND i1yrs11i = ${global.t?.state.s_i1yrs11i}`
          return _cnd;
        }
      : ( global.t?.class == 'i1yv1b') ?
        _dd_datss => {
          let _cnd = cf.c('i1yr', 'i1yri12i > 0', false, false); // i1yr は歴管理対象外
          if (ff.f(global.t?.state.s_i1yri11dStt)) _cnd += ` AND i1yri11d >= "${global.t?.state.s_i1yri11dStt}"`; // 利用日
          if (ff.f(global.t?.state.s_i1yri11dEnd)) _cnd += ` AND "${global.t?.state.s_i1yri11dEnd}" >= i1yri11d`; // 利用日
          if (global.t?.state.s_i1yrs12i >= 0) _cnd += ` AND i1yrs12i = ${global.t?.state.s_i1yrs12i}`
          //ff.l('I1yv 77: {}'.f(_cnd));
          return _cnd;
        }
      : null,
      ld_sortss: 
        ( global.t?.class == 'i1yv1a') ?
          [
//            { fld: `i1yrs11i`, dtn: 'asc', mode: 'nmb'},
//            { fld: `i1yri11d`, dtn: 'asc', mode: 'str'},
            { fld: `i1yri11d`, dtn: 'desc', mode: 'str'},
          ]
        : ( global.t?.class == 'i1yv1b') ?
          [
//            { fld: `i1yrs12i`, dtn: 'asc', mode: 'nmb'},
//            { fld: `i1yri12d`, dtn: 'asc', mode: 'str'},
            { fld: `i1yri12d`, dtn: 'desc', mode: 'str'},
          ]
        : null,
    })
  : super.op_loadList;

$clp_loadLists = () => [ // 親を上書き
  i1yv.op_loadList({ // 会議室・設備
    elm:'i1yr',
  }),
  i10v1a.op_loadSlcList({ // 会議室・設備
    elm:'i10r',
  }),
  i11v1a.op_loadSlcList({ // 時間帯
    elm: 'i110',
  }),
  c20v1a.op_loadDtl({ // 団体
    elm: 'c20r',
  })
];

$clp_loadDtls = () => [
];

$clp_upds = () => [
];

static op_upsI1yri11i = (pd={
  i1yri11d: null,
})=> new Promise( _o_end1 => {
  cf.myCB_callQrys({
    l_tgts: [
      'i1yri11i',
    ],
    d_vals: {
      i1yri11d: pd.i1yri11d,
    }
  })
});

static op_upsI1yri12i = (pd={
  i1yri11d: null,
})=> new Promise( _o_end1 => {
  cf.myCB_callQrys({
    l_tgts: [
      'i1yri12i',
    ],
    d_vals: {
      i1yri11d: pd.i1yri11d,
    }
  })
});

_o_eptPdf01 = (pd_i1yrs) => { // 利用申請書
/*
  let _i1yri11d = _d_i1yrs.d_flds.i1yri11d;
  await i1zv1b.op_loadList({ // 更新対象の取得
    elm: 'i1zr',
    o_cnd: 
      ( global.t?.class == 'i1yv1a') ?
        _dd_datss => {
          let _cnd = cf.c(`i1zr`, `i1zri21d = "${_i1yri11d}" AND i1zrs21i = 40`);
          return _cnd;
        }
      : ( global.t?.class == 'i1yv1b') ?
        _dd_datss => {
          let _cnd = cf.c(`i1zr`, `i1zri21d = "${_i1yri11d}" AND i1zrs22i = 40`);
          return _cnd;
        }
      : null, 
  })
*/
//ff.l('I1yv 143: {}'.f(pd_i1yrs));
  const _d_i1yrs = pd_i1yrs;
  const _i1yri11d = _d_i1yrs.d_flds.i1yri11d; // 利用日
  const _cnd = 
    ( global.t?.class == 'i1yv1a') ? // エントリー抽選
      cf.c(`i1zr`, `i1zri21d = "${_i1yri11d}" AND i1zrs21i = 80`) // 該当日の当選
    : ( global.t?.class == 'i1yv1b') ? // 優先エントリー抽選
        cf.c(`i1zr`, `i1zri21d = "${_i1yri11d}" AND i1zrs22i = 80`) // 該当日の当選
    : null;
//ff.l('I1yv 152: {}'.f(_cnd));
  i1zv1b.op_loadList({ // 処理対象
    elm: 'i1zr',
    o_cnd: () => _cnd, 
  })
  .then(() => {
//ff.l('I1yv 158: here');
    const _name = 
      ( global.t?.class == 'i1yv1a') ? // エントリー抽選
        `利用申請書_${_i1yri11d}エントリー_${ff.myDT_getDate('today').replace(/-/g, '')}.pdf`
      : ( global.t?.class == 'i1yv1b') ? // 優先エントリー抽選
        `利用申請書_${_i1yri11d}優先エントリー_${ff.myDT_getDate('today').replace(/-/g, '')}.pdf`
      : null;
    const _l_fsts = global.t?.state.sdld_i1zrListsss.i1zr.map( _d_i1zrs => {
//ff.l('I1yv 160: {}'.f(_d_i1zrs));
      return _d_i1zrs.d_flds._fst;
    });
    i1zv1b._eptPdf1({
      name: _name,
      l_fsts: _l_fsts,
    });
  });
};

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -1,
            mode: 'list',
            b_vsb: global.t?.state.sgc_pnlMode == 'list' ? true : false,

            d_hdrs: {
              d_ctrs: {
                l_clds: [
                  ce.c(ce.PckDate, cf.f('i1yri11d', { // 利用日
                    key: -1.1, 
                    b_vsb: true,
                    b_edit: true,
                    b_row: true,
                    b_rvs: true,
                    state: 's_i1yri11dStt',
                    n_col: 8,
                    d_stlCtas: {
                      marginLeft: ic.m(1),
                    }
                  })),
                  ce.c(ce.PckDate, cf.f('i1yri11d', { // 利用日
                    pfx: '〜',
                    key: -1.2, 
                    b_vsb: true,
                    b_edit: true,
                    b_row: true,
                    b_rvs: true,
                    state: 's_i1yri11dEnd',
                    n_col: 8,
                    d_stlCtas: {
                      marginLeft: ic.m(1),
                    }
                  })),
                  ( global.t?.class == 'i1yv1a') ?
                    ce.c(ce.Pck, cf.f('i1yrs11i', {
                      key: -3, 
                      b_vsb: true,
                      b_edit: true,
                      b_row: true,
                      b_rvs: true,
                      state: 's_i1yrs11i',
                      ld_iss: [
                        { key:  0, pfx: '抽選前' },
                        { key: 20, pfx: '抽選済み' },
                      ],
                    }))
                  : ( global.t?.class == 'i1yv1b') ?
                    ce.c(ce.Pck, cf.f('i1yrs12i', {
                      key: -3, 
                      b_vsb: true,
                      b_edit: true,
                      b_row: true,
                      b_rvs: true,
                      state: 's_i1yrs12i',
                      ld_iss: [
                        { key:  0, pfx: '抽選前' },
                        { key: 20, pfx: '抽選済み' },
                      ],
                    }))
                  : null,
                  ce.c(ce.BtnIconPfx, {
                    key: -4, 
                    b_vsb: true,
                    b_row: true,
                    iconName: 'search',
                    pfx: '検索',
                    o_onPrs: () => global.t?.op_loadListAll(),
                  }),
                ],
              },
            },

            d_bdys: {
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [

                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i1yrListsss',
                    dd_elmDefss: {
                      i1yr: {
                        elm: 'i1yr',
                        b_row: true,
                        b_ttl: false,
                        b_rootHdr: true,
                        d_chks: {
                          b_hdr: false,
                          b_vsb: global.t?.state.sgc_pageMode == 'edit' ? true : false,
                        },
                        d_btns: {
                          d_anys: {
                            b_vsb: true,
                            pfx: 'エントリーを確認',
                            o_onPrs: () => {
                            },
                          }
                        },
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: 
                          ( global.t?.class == 'i1yv1a') ?
                            cf.myRN_getFldDefs([
                              cf.f('i1yri11d', {
                                b_edit: false,
                                d_hdrs: { n_w: ic.s(8) },
                                d_bdys: { n_w: ic.s(8) },
                              }),
                              cf.f('i1yri11i', {
                                b_edit: false,
                                d_hdrs: { n_w: ic.s(10) },
                                d_bdys: { n_w: ic.s(10) },
                              }),
                              cf.f('i1yrs11i', {
                                b_edit: false,
                                d_hdrs: { n_w: ic.s(10) },
                                d_bdys: { n_w: ic.s(10) },
                              }),
                              cf.f('i1yri21d', {
                                b_edit: false,
                                d_hdrs: { n_w: ic.s(8) },
                                d_bdys: { n_w: ic.s(8) },
                              }),
                              global.t?.state.s_i1yrs11i == 20 ? // 抽選済
                              {
                                type: 'Btn',
                                n_col: 8,
                                pfx: '利用申請書',
                                o_onPrs: _d_is => {
                                  global.t?._o_eptPdf01(_d_is);
                                },
                                d_ctrStls: {
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: ic.s(0.6),
                                }
                              }
                              : null,
                            ])
                          : ( global.t?.class == 'i1yv1b') ?
                            cf.myRN_getFldDefs([
                              cf.f('i1yri11d', {
                                b_edit: false,
                                d_hdrs: { n_w: ic.s(8) },
                                d_bdys: { n_w: ic.s(8) },
                              }),
                              cf.f('i1yri12i', {
                                b_edit: false,
                                d_hdrs: { n_w: ic.s(10) },
                                d_bdys: { n_w: ic.s(10) },
                              }),
                              cf.f('i1yrs12i', {
                                b_edit: false,
                                d_hdrs: { n_w: ic.s(10) },
                                d_bdys: { n_w: ic.s(10) },
                              }),
                              cf.f('i1yri22d', {
                                b_edit: false,
                                d_hdrs: { n_w: ic.s(8) },
                                d_bdys: { n_w: ic.s(8) },
                              }),
                              global.t?.state.s_i1yrs12i == 20 ? // 抽選済
                              {
                                type: 'Btn',
                                n_col: 8,
                                pfx: '利用申請書',
                                o_onPrs: _d_is => {
                                  global.t?._o_eptPdf01(_d_is);
                                },
                                d_ctrStls: {
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: ic.s(0.6),
                                }
                              }
                              : null,
                            ])
                          : null,

                      },
                    },
                  }),
                ])
              ],
            },

            d_btms: {
              l_clds: [
                ce.c(ce.Btn, {
                  key: -2,
//                  pfx: '抽選を行う',
                  pfx: 'エントリー抽選画面へ',
                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['show']) ? true : false,
                  o_onPrs: () => {
                    cf.myRN_savePageStgs({
                      sgc_pageMode: 'edit',
                    })
                  },
                  stlCta: {
                    marginTop: ic.s(1),
                    marginBottom: ic.s(1),
                  },
                  stlBtn: {
                    width: ic.s(16),
                  },
                }),

                ce.c(ce.Row, {
                  key: -3,
                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['edit']) ? true : false,
                  stlCta: {
                    width: ic.gn_minBdyW,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  },
                }, [
                  ce.c(ce.Btn, {
                    key: -1,
//                    pfx: 'キャンセル',
                    pfx: '前の画面に戻る',
                    o_onPrs: () => {
                      cf.myRN_savePageStgs({
                        sgc_pageMode: 'show',
                      })
                    },
                    stlCta: {
                      marginTop: ic.s(1),
                      marginBottom: ic.s(1),
                    },
                    stlBtn: {
                      width: ic.s(10),
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                  }),

                  ce.c(ce.Btn, {
                    key: -2,
                    pfx: '選択した日付を抽選',
                    o_onPrs: async () => {
                      cf.s();
                      for await (let [_idxI1yr, _d_i1yrs] of ff.e(global.t?.state.sdld_i1yrListsss.i1yr)) {
                        if (_d_i1yrs.b_chk) { // 選択した日付の場合
                          let _i1yri11d = _d_i1yrs.d_flds.i1yri11d;
                          await i1zv1b.op_loadList({ // 更新対象の取得
                            elm: 'i1zr',
                            o_cnd: 
                              ( global.t?.class == 'i1yv1a') ?
                                _dd_datss => {
                                  let _cnd = cf.c(`i1zr`, `i1zri21d = "${_i1yri11d}" AND i1zrs21i = 40`);
                                  return _cnd;
                                }
                              : ( global.t?.class == 'i1yv1b') ?
                                _dd_datss => {
                                  let _cnd = cf.c(`i1zr`, `i1zri21d = "${_i1yri11d}" AND i1zrs22i = 40`);
                                  return _cnd;
                                }
                              : null, 
                          })
                          .then( async () => {
                            let _n_cnt = ff.myCM_getLen(global.t?.state.sdld_i1zrListsss.i1zr);
                            for await (let [_idx, _i] of ff.e(ff.myCM_getRng(_n_cnt, 1, true))) { // ランダムな順に前から一つずつ実行
                              let _d_i1zrs = global.t?.state.sdld_i1zrListsss.i1zr[_i - 1];
                              let _b_sgl1 = await i1zv1b.op_chkSglI10r({ // 室の重複チェック
                                d_i1zrs: _d_i1zrs,
                                pageMode: 'new',
                              });
                              let _b_sgl2 = await i1zv1b.op_chkSglI10r2({ // 設備の重複チェック
                                d_i1zrs: _d_i1zrs,
                                pageMode: 'new',
                              });
                              if (_b_sgl1 && _b_sgl2) { // 他の予約なし -> 当選
                                await i1zv1b.op_updStt(
                                  ( global.t?.class == 'i1yv1a') ?
                                    { // 状況の更新
                                      fst: _d_i1zrs.d_flds._fst,
                                      i1zrs11i: 80, // 当選の場合
                                      i1zrs21i: 80, // 当選の場合
                                      i1zrs22i:  0, // 当選の場合
                                    }
                                  : ( global.t?.class == 'i1yv1b') ?
                                    { // 状況の更新
                                      fst: _d_i1zrs.d_flds._fst,
                                      i1zrs11i: 80, // 当選の場合
                                      i1zrs21i:  0, // 当選の場合
                                      i1zrs22i: 80, // 当選の場合
                                    }
                                  : null
                                )
                                .then( async () => {
                                  let _ttl = 
                                    ( global.t?.class == 'i1yv1a') ?
//                                      `地区センターからエントリー抽選結果のお知らせ(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`
                                      `エントリー当選のお知らせ (ID：${_d_i1zrs.d_flds.i1zrc11s})(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`
                                    : ( global.t?.class == 'i1yv1b') ?
//                                      `地区センターから優先エントリー抽選結果のお知らせ(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`
                                      `優先エントリー当選のお知らせ (ID：${_d_i1zrs.d_flds.i1zrc11s})(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`
                                    : null;

                                  let _msg = 
                                    ( global.t?.class == 'i1yv1a') ?
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
エントリー抽選結果をご連絡致します。
下記エントリーが当選し、正式な予約として登録致しました。

<<< エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------
${global.t?.state.sgcd_stgs._03020100}

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${global.t?.state.sgcd_stgs._00050100}
-------------------------------------------------
`
                                    : ( global.t?.class == 'i1yv1b') ?
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
優先エントリー抽選結果をご連絡致します。
下記優先エントリーが当選し、正式な予約として登録致しました。

<<< 優先エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------
${global.t?.state.sgcd_stgs._03020100}

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${global.t?.state.sgcd_stgs._00050100}
-------------------------------------------------
`
: null;
/*
                                  if (ff.f(_d_i1zrs.d_flds.c30rig1s)) {
                                    cf.myCB_call_eml(
                                      _d_i1zrs.d_flds.c30rig1s,
                                      _ttl,
                                      _msg,
                                    );
                                  }
                                  if (ff.f(_d_i1zrs.d_flds.c30rig2s)) {
                                    cf.myCB_call_eml(
                                      _d_i1zrs.d_flds.c30rig2s,
                                      _ttl,
                                      _msg,
                                    );
                                  }
                                  if (ff.f(_d_i1zrs.d_flds.c30rig3s)) {
                                    cf.myCB_call_eml(
                                      _d_i1zrs.d_flds.c30rig3s,
                                      _ttl,
                                      _msg,
                                    );
                                  }
*/
                                  const _l_tos = [];
                                  if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                  if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                  if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                  const _l_bccs = [ic.g_mail];
                                  if (ff.f(global.t?.state.sgcd_stgs._00050200)) _l_bccs.push(global.t?.state.sgcd_stgs._00050200);                                  
                                  await cf.myCB_call_eml(
                                    _l_tos,
                                    _ttl,
                                    _msg,
                                    _l_bccs
                                  );
                                  await ff.myCM_wait(4);
                                });
                              }
                              else { // 他の予約あり -> 落選
                                //ff.l('309: {}, {}, {}'.f(_b, _d_i1zrs.d_flds._fst, _d_i1zrs));
                                await i1zv1b.op_updStt(
                                  ( global.t?.class == 'i1yv1a') ?
                                    { // 状況の更新
                                      fst: _d_i1zrs.d_flds._fst,
                                      i1zrs11i: 60, // 落選の場合
                                      i1zrs21i: 60, // 落選の場合
                                      i1zrs22i:  0, // 落選の場合
                                    }
                                  : ( global.t?.class == 'i1yv1b') ?
                                    { // 状況の更新
                                      fst: _d_i1zrs.d_flds._fst,
                                      i1zrs11i: 60, // 落選の場合
                                      i1zrs21i:  0, // 落選の場合
                                      i1zrs22i: 60, // 落選の場合
                                    }
                                  : null
                                )
                                .then( async () => {

                                  let _ttl = 
                                    ( global.t?.class == 'i1yv1a') ?
//                                      `地区センターからエントリー抽選結果のお知らせ(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`
                                      `エントリー抽選結果のお知らせ (ID：${_d_i1zrs.d_flds.i1zrc11s})(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`
                                    : ( global.t?.class == 'i1yv1b') ?
//                                      `地区センターから優先エントリー抽選結果のお知らせ(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`
                                      `優先エントリー抽選結果のお知らせ (ID：${_d_i1zrs.d_flds.i1zrc11s})(${global.t?.state.sgcd_cmnStgs?.c20r_pfx})`
                                    : null;
                                  
                                  

                                  let _msg = 
                                    ( global.t?.class == 'i1yv1a') ?
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
エントリー抽選結果をご連絡致します。
下記エントリーについて抽選の結果、
残念ながら今回はご期待に沿えない結果となりました。

<<< エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${global.t?.state.sgcd_stgs._00050100}
-------------------------------------------------
`
                                    : ( global.t?.class == 'i1yv1b') ?
`団体番号：${_d_i1zrs.d_flds.c30rc11s}
${_d_i1zrs.d_flds.c30rc31s}　様
-------------------------------------------------
優先エントリー抽選結果をご連絡致します。
下記優先エントリーについて抽選の結果、
残念ながら今回はご期待に沿えない結果となりました。

<<< 優先エントリー内容 >>>　　(ID：${_d_i1zrs.d_flds.i1zrc11s})

■利用日：　${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}
■部屋：　${_d_i1zrs.d_flds.i10rc31s}
■利用時間帯：　${_d_i1zrs.d_flds.i1zri62s}

-------------------------------------------------

※このメールは配信専用です。返信されても対応は出来ませんので、ご了承ください。
-------------------------------------------------
${global.t?.state.sgcd_stgs._00050100}
-------------------------------------------------
`
                                    : null;
//ff.l('320: {}'.f(_msg))
                                  const _l_tos = [];
                                  if (ff.f(_d_i1zrs.d_flds.c30rig1s)) _l_tos.push(_d_i1zrs.d_flds.c30rig1s);
                                  if (ff.f(_d_i1zrs.d_flds.c30rig2s)) _l_tos.push(_d_i1zrs.d_flds.c30rig2s);
                                  if (ff.f(_d_i1zrs.d_flds.c30rig3s)) _l_tos.push(_d_i1zrs.d_flds.c30rig3s);
                                  const _l_bccs = [ic.g_mail];
                                  if (ff.f(global.t?.state.sgcd_stgs._00050200)) _l_bccs.push(global.t?.state.sgcd_stgs._00050200);                                  
                                  await cf.myCB_call_eml(
                                    _l_tos,
                                    _ttl,
                                    _msg,
                                    _l_bccs
                                  );
                                  await ff.myCM_wait(4);
                                });
                              }
                            };
                            //ff.l('342: here')
                            await cf.myCB_callQrys({ // 全ての処理が完了した後、進捗を更新
                              l_tgts: 
                                ( global.t?.class == 'i1yv1a') ?
                                  [
                                    'i1yrs11i',
                                  ]
                                : ( global.t?.class == 'i1yv1b') ?
                                  [
                                    'i1yrs12i',
                                  ]
                                : null,
                              d_vals: {
                                i1yri11d: _i1yri11d,
                              },
                            });
                          })
                        }
                      };
                      global.t?.op_loadListAll()
                      .then(() => {
                        cf.myRN_savePageStgs({
                          sgc_pageMode: 'show',
                        })
                        .then(() => {
                          alert('抽選が終わりました')
                          cf.h();
                        });
                      });
                    },
                    stlCta: {
                      marginTop: ic.s(1),
                      marginBottom: ic.s(1),
                    },
                    stlBtn: {
                      width: ic.s(10),
                    },
                  }),

                ]),

              ],
            }
          }),

        ],
      }
    })
  );
}

}
